import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import FlagIcon from '../../../icons/FlagIcon.jsx';
import { TriangleBlueIcon } from '../../../icons/TriangleBlueIcon.jsx';

const MilestoneCard = ({
  name,
  notes,
  date_at,
  isTotalShow,
  projectMilestone,
}) => {
  const [isShowMore, setIsShowMore] = useState(false);
  const [isShowMoreBtnNeed, setIsShowMoreBtnNeed] = useState(false);

  useEffect(() => {
    const viewNote = document.getElementById(name);
    if (viewNote && viewNote.scrollHeight > viewNote.clientHeight) {
      setIsShowMoreBtnNeed(true);
    }
  }, []);

  const timestamp = date_at;
  const date = moment.parseZone(timestamp);

  const formattedDate = date.format('MM/DD/YY');
  return (
    <div className="milestone-card m-t-28" style={{ position: 'relative' }}>
      {isTotalShow ? (
        <strong
          className="bordered text-muted"
          style={{ position: 'absolute', right: 0 }}
        >
          Total:&nbsp;
          <span className="count" style={{ color: '#27B0E0' }}>
            2
          </span>
        </strong>
      ) : null}

      <h5 className="flex m-b-16">
        <div
          className="flex header-item bordered m-r-8"
          style={{ borderColor: projectMilestone ? '#27B0E0' : '#5771CA' }}
        >
          <FlagIcon fill={projectMilestone ? '#27B0E0' : '#5771CA'} />
        </div>
        {formattedDate}
      </h5>
      <h5 className="m-b-16">{name}</h5>
      {notes?.length ? (
        <div
          id={name}
          className={!isShowMore && 'notes'}
          style={{ color: '#7F8FA4' }}
        >
          {notes}
        </div>
      ) : null}
      {isShowMoreBtnNeed ? (
        <Button
          aria-label={isShowMore ? 'Show More' : 'Show Less'}
          type="button"
          onClick={() => setIsShowMore(!isShowMore)}
          className="flex flex-align-center btn-link px-0"
        >
          {!isShowMore ? (
            <span className="flex flex-align-center">
              <span className="m-r-8">Show More</span>
              <TriangleBlueIcon
                style={{ height: '20px' }}
                transform="rotate(180)"
              />
            </span>
          ) : (
            <span className="flex flex-align-center">
              <span className="m-r-8">Show Less</span>
              <TriangleBlueIcon style={{ height: '20px' }} />
            </span>
          )}
        </Button>
      ) : null}
    </div>
  );
};

export default MilestoneCard;
